/**
 * WAF domain-tag catalog — the customer's account-wide domain tags, backed by
 * `GET /services/:service_id/waf/tags` (service-scoped). Used to populate the domain list's tag
 * filter.
 */
import { useQuery } from '@tanstack/react-query';
import { serviceApiV3, wafKeys, unwrapList, type WafTag } from './_shared';

/** List the domain tags available to this service. */
export function useWafTags(serviceId: string | undefined) {
  return useQuery<WafTag[]>({
    queryKey: wafKeys.tags(serviceId ?? ''),
    enabled: !!serviceId,
    staleTime: 5 * 60_000,
    queryFn: async () =>
      unwrapList<WafTag>(
        await serviceApiV3.get(`/services/${serviceId}/waf/tags`),
      ).items,
  });
}
